import { Tag } from '@oscar/theme';
import { STATUS_COLOR_TABLE } from 'common/constants';
import React from 'react';
import './style.scss';

function StatusTagColumnTable(props: any) {
  let color = '#677C91';
  let backgroundColor = '#9FB0C2';
  let statusLabel = '';
  STATUS_COLOR_TABLE?.map(item => {
    if (item.TYPE === props) {
      color = item.COLOR;
      backgroundColor = item.BACKGROUND_COLOR;
      statusLabel = item.STATUS_LABEL;
    } else if (item.TYPE === props?.value) {
      color = item.COLOR;
      backgroundColor = item.BACKGROUND_COLOR;
      statusLabel = item.STATUS_LABEL;
    }
  });

  return (
    <Tag
      className="status-tag-column-table"
      color={backgroundColor}
      style={{
        color: `${color}`,
        fontWeight: '500',
        height: 'fit-content',
        alignSelf: 'center',
      }}
    >
      {statusLabel}
    </Tag>
  );
}

export default StatusTagColumnTable;
